import React from 'react';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { AppState } from 'store/reducers';
import { useSelector, useDispatch } from 'react-redux';
import { MainFormState } from 'types/forms/form.def';
import { addClient as addClientAction } from 'store/actions';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { Switch } from 'components/atoms/Buttons/Switchs/Switch';
import useStyle from '../formCommande.style';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';

const ProFields = ({
  onChange,
  defaultValues
}: {
  onChange?: (e: any) => void;
  defaultValues?: any;
}) => {
  const classes = useStyle();
  const { client } = useSelector((state: AppState) => state);

  if (defaultValues && client) {
    client.values = defaultValues;
  }

  const dispatch = useDispatch();
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));

  const handleChange = async e => {
    const value = e.target.value;
    const field = e.target.name;

    if (client.values.affilie || !client.values.livraisonhorslycee) {
      client.errors = {
        ...client.errors,
        mobilelivraison: false,
        nomlivraison: false,
        prenomlivraison: false
      };
    }

    if (field === 'clientpro' && value === 'false') {
      client.values = { ...client.values, nomsociete: null };
    }

    const newParams = errorAndStateParams(field, value, client);
    addClient(newParams);
    if (onChange) {
      onChange(e);
    }
  };
  const handleChangeSwitch = (value, name) => {
    const e = {
      target: {
        value: value.toString(),
        name: name
      }
    };
    handleChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      <div className={classes.buttondiv}>
        <p>Client Professionnel ?</p>
        <Switch
          onClick={value => handleChangeSwitch(value, 'clientpro')}
          defaultValue={client.values.clientpro}
        />
      </div>
      {client.values.clientpro && (
        <>
          <HeaderText text="Nom de la société" emoji={emojis['Factory']} />
          <div style={{ width: '100%' }}>
            <FeatureContainer>
              <LabelInput
                label="Nom de la société"
                name="nomsociete"
                placeHolder="ex : Boulangerie de la maison"
                onChange={handleChange}
                value={client.values.nomsociete || ''}
                required={true}
                error={client.errors && client.errors.nomsociete}
              />
            </FeatureContainer>
          </div>
        </>
      )}
    </>
  );
};
export default ProFields;
